/* global __SERVER_VAR_EN_API_HOST__ */
import axios from 'axios'
import lscache from 'lscache'

const REQTIMEOUT = 20000
const DEFAULT_DOMAIN = __SERVER_VAR_EN_API_HOST__
const DEFAULT_HEADERS = { 'Content-Type': 'multipart/form-data', 'X-Soompi-app-id': '200000a' }
const DEFAULT_PARAMS = {}
const UUID_KEY = 'localstorage_uuid'
const UUID_NOT_FOUND = 'not-found'

const post = ({ url = '', domain = DEFAULT_DOMAIN, params = DEFAULT_PARAMS, headers = DEFAULT_HEADERS, timeout = REQTIMEOUT }) => {
  return axios.create({ timeout, headers }).post(`${domain}/${url}`, params)
}

const get = ({ url = '', domain = DEFAULT_DOMAIN, params = DEFAULT_PARAMS, headers = DEFAULT_HEADERS, timeout = REQTIMEOUT }) => {
  return axios.create({ timeout, headers }).get(`${domain}/${url}`, { params: params })
}

const patch = ({ url = '', domain = DEFAULT_DOMAIN, params = DEFAULT_PARAMS, headers = DEFAULT_HEADERS, timeout = REQTIMEOUT }) => {
  return axios.create({ timeout, headers }).patch(`${domain}/${url}`, params)
}

const put = ({ url = '', domain = DEFAULT_DOMAIN, params = DEFAULT_PARAMS, headers = DEFAULT_HEADERS, timeout = REQTIMEOUT }) => {
  return axios.create({ timeout, headers }).put(`${domain}/${url}`, params)
}

const isWindowAvailable = () => {
  return typeof window === 'object'
}

const isDocumentAvailable = () => {
  return typeof document === 'object'
}

const getStoredUUID = () => {
  let uuid = UUID_NOT_FOUND
  if ((typeof window !== 'undefined') && lscache.supported()) {
    const tempUUID = lscache.get(UUID_KEY)
    if (tempUUID) {
      uuid = tempUUID
    }
  }
  return uuid
}

const generateUUID = () => {
  // Feature detect for the WHATWG crypto API. See
  // http://wiki.whatwg.org/wiki/Crypto
  let rnds = []
  rnds[0] = Math.random() * 0x100000000
  rnds[1] = Math.random() * 0x100000000
  rnds[2] = Math.random() * 0x100000000
  rnds[3] = Math.random() * 0x100000000

  let i = 0
  let b = []

  b[i++] = rnds[0] & 0xff
  b[i++] = rnds[0] >>> 8 & 0xff
  b[i++] = rnds[0] >>> 16 & 0xff
  b[i++] = rnds[0] >>> 24 & 0xff

  b[i++] = rnds[1] & 0xff
  b[i++] = rnds[1] >>> 8 & 0xff
  b[i++] = rnds[1] >>> 16 & 0x0f | 0x40 // See RFC4122 sect. 4.1.3
  b[i++] = rnds[1] >>> 24 & 0xff

  b[i++] = rnds[2] & 0x3f | 0x80 // See RFC4122 sect. 4.4
  b[i++] = rnds[2] >>> 8 & 0xff
  b[i++] = rnds[2] >>> 16 & 0xff
  b[i++] = rnds[2] >>> 24 & 0xff

  b[i++] = rnds[3] & 0xff
  b[i++] = rnds[3] >>> 8 & 0xff
  b[i++] = rnds[3] >>> 16 & 0xff
  b[i++] = rnds[3] >>> 24 & 0xff

  let tempStr = b.map((val) => {
    return (val + 0x100).toString(16).substr(1)
  }).join('')
  let dashes = [8, 13, 18, 23]

  return dashes.reduce((acc, dash) => {
    return `${acc.slice(0, dash)}-${acc.slice(dash)}`
  }, tempStr)
}
if (typeof window !== 'undefined') {
  window.generateUUID = generateUUID
}

const insertUUID = () => {
  let uuid = UUID_NOT_FOUND
  if ((typeof window !== 'undefined') && lscache.supported()) {
    uuid = generateUUID()
    lscache.set(UUID_KEY, uuid)
  }
  return uuid
}

// GET AND/OR INSERT UUID depending on whether it exists
const getsertStoredUUID = () => {
  let uuid = getStoredUUID()
  if (uuid === UUID_NOT_FOUND) {
    uuid = insertUUID()
  }
  return uuid
}

module.exports = {
  get,
  post,
  patch,
  put,
  generateUUID,
  getsertStoredUUID,
  isWindowAvailable,
  isDocumentAvailable
}



// WEBPACK FOOTER //
// ./assets/js/helpers/Utils.jsx